//NEWS
export const GET_NEWS = "/news"
export const ADD_NEW_NEWS = "/news"
export const UPDATE_NEWS = "/news"
export const DELETE_NEWS = "/news"
export const GET_NEWS_CATEGORIES_PUBLISHED = "/noticiascategory"
export const GET_NEWS_PUBLISHED = "/docentes/noticias"
export const GET_NEWS_LAST_PUBLISHED = "/docentes/noticias"
